var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71409 0.242432C5.85629 0.381795 5.94284 0.56812 5.95775 0.766663C5.97265 0.965205 5.91482 1.16238 5.79503 1.32141L5.71409 1.41339L2.02904 5.00641L5.71409 8.59943C5.85629 8.73879 5.94284 8.92511 5.95775 9.12366C5.97265 9.3222 5.91482 9.51937 5.79503 9.67841L5.71409 9.77142C5.57079 9.91215 5.38217 9.9975 5.18187 10.0123C4.98157 10.0272 4.78257 9.9705 4.6201 9.85242L4.52598 9.77142L0.246077 5.59241C0.103883 5.45304 0.0172068 5.26672 0.00230234 5.06818C-0.0126022 4.86963 0.0452282 4.67246 0.165022 4.51343L0.246077 4.42041L4.52598 0.242432C4.68466 0.0870522 4.89802 0 5.1201 0C5.34218 0 5.55542 0.0870522 5.71409 0.242432Z",
    fill: "#FF6666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.a3ea5847394a3084805f509e48da5b7e.svg";
export { ForwardRef as ReactComponent };